module.exports = __webpack_public_path__ + "static/media/visa.48092f34.svg";